import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router";

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const redirectHandler = () => {
    navigate("/app/dashboard");
  };

  return (
    <Result
      status="404"
      title="404"
      subTitle="Désolé, la page que vous voulez visiter n’existe pas."
      extra={
        <Button type="primary" onClick={redirectHandler}>
          Accueil
        </Button>
      }
    />
  );
};
